import { TypeOfCancer } from '@/components/icons/icon-catch/types';

const cancerMapping: Partial<Record<TypeOfCancer, string>> = {
  endometrial: 'uterine',
};

export function mapCancerType(cancerType: TypeOfCancer) {
  return cancerMapping[cancerType] || cancerType;
}
